"use client";

import { Facebook, Instagram, Music2, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4, 5].map(i => <li key={i} data-index={i} className="h-5 w-32 bg-muted/40 animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="group relative inline-block font-default font-medium text-[0.95rem] text-foreground/90 hover:text-primary transition-colors duration-200">
            <span>{item.label}</span>
            <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-[260ms] ease-out group-hover:w-full" />
          </Link>
        </li>)}
    </ul>;
}
const tickerItems = ["NEXUS TALENT", "EXECUTIVE SEARCH", "PROFESSIONAL GROWTH", "NEXUS TALENT", "EXECUTIVE SEARCH", "PROFESSIONAL GROWTH", "NEXUS TALENT", "EXECUTIVE SEARCH", "PROFESSIONAL GROWTH"];
const socials = [{
  name: "Instagram",
  href: "#",
  icon: Instagram
}, {
  name: "Facebook",
  href: "#",
  icon: Facebook
}, {
  name: "TikTok",
  href: "#",
  icon: Music2
}, {
  name: "YouTube",
  href: "#",
  icon: Youtube
}];
const bottomLinks = [{
  label: "Privacy",
  href: "#"
}, {
  label: "Terms",
  href: "#"
}, {
  label: "Accessibility",
  href: "#"
}];
export default function CorporateFooter() {
  return <section data-section-id="1200" id="corporate-footer" className="dark bg-secondary text-foreground relative overflow-hidden pt-0 pb-10">
      {}
      <div className="relative w-full overflow-hidden bg-primary border-b border-border">
        <div className="flex whitespace-nowrap py-3 animate-[ticker_40s_linear_infinite]">
          {[...tickerItems, ...tickerItems].map((item, i) => <span data-index={i} key={i} className="font-mono text-[0.8125rem] tracking-[0.18em] text-secondary uppercase px-6 flex items-center">
              {item}
              <span className="ml-6 inline-block size-1.5 rounded-lg bg-secondary" />
            </span>)}
        </div>
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.07] mix-blend-overlay" style={{
      backgroundImage: "radial-gradient(hsl(0 0% 100%) 1px, transparent 1px)",
      backgroundSize: "3px 3px"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 -right-10 select-none font-serif font-light text-[22rem] leading-none opacity-[0.06] text-foreground" style={{
      WebkitTextStroke: "2px currentColor",
      color: "transparent"
    }}>
        N
      </div>

      {}
      <div className="relative container mx-auto px-6 md:px-10 lg:px-16 pt-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          {}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="mt-6 font-serif italic font-light text-[1.25rem] leading-snug text-foreground/80 max-w-sm">
              Architects of professional evolution — since 2005
            </p>
            <p className="mt-4 font-mono text-[0.75rem] tracking-[0.18em] uppercase text-foreground/60">
              — Global Headquarters
            </p>
          </div>

          {}
          <div className="md:col-span-3">
            <h3 className="font-default font-mono text-[0.75rem] tracking-[0.18em] uppercase text-foreground/60 mb-6">
              — Navigation
            </h3>
            <MenuProvider menu_id="38">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="font-default font-mono text-[0.75rem] tracking-[0.18em] uppercase text-foreground/60 mb-6">
              — Contact
            </h3>
            <address className="not-italic space-y-2 font-default text-[0.95rem] text-foreground/85 leading-relaxed">
              <div>450 Executive Plaza, New York</div>
              <div>
                <Link to="tel:+15559876543" className="hover:text-primary transition-colors duration-200">
                  (555) 987-6543
                </Link>
              </div>
              <div>
                <Link to="mailto:connect@nexus.com" className="hover:text-primary transition-colors duration-200">
                  connect@nexus.com
                </Link>
              </div>
              <div className="font-mono text-[0.8125rem] tracking-[0.04em] text-foreground/70 pt-2">
                Mon–Fri: 09:00 AM – 06:00 PM
              </div>
            </address>

            <div className="mt-8 flex items-center gap-5">
              {socials.map((s, i) => {
              const Icon = s.icon;
              return <Link data-index={i} key={s.name} to={s.href} aria-label={s.name} className="text-foreground hover:text-primary transition-colors duration-[220ms]">
                    <Icon strokeWidth={1.75} className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-foreground/15">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <p className="font-mono text-[0.75rem] tracking-[0.04em] text-foreground/60">
              © 2025 NEXUS TALENT PARTNERS · All rights reserved
            </p>
            <ul className="flex flex-wrap items-center gap-x-4 gap-y-2">
              {bottomLinks.map((link, i) => <li data-index={i} key={link.label} className="flex items-center gap-4">
                  <Link to={link.href} className="font-mono text-[0.75rem] tracking-[0.04em] text-foreground/60 hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                  {i < bottomLinks.length - 1 && <span className="text-foreground/40 font-mono text-[0.75rem]">·</span>}
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}